import React from 'react';
import { TextField, Box, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';

import useQuestion from './useQuestion';
import RenderIf from '../../../../renderIf';

const useStyles = makeStyles(() => ({
    singleLinePlainText: {
        width: 400,
    },
    readOnly: {
        '&.MuiOutlinedInput-input.Mui-disabled': {
            backgroundColor: '#EFEFEF',
            color: '#586874',
            fontSize: '15px',
            '-webkit-text-fill-color': 'unset',
            outline: 'none',
        },
        '&.MuiOutlinedInput-root': {
            '& > fieldset': {
                border: '1px solid #EFEFEF',
                borderRadius: '8px',
            },
        },
    },
}));

const SingleLineText = (props) => {
    const { question, disabled, readOnly } = props;

    const classes = useStyles();

    const { isInvalid, isSaving, answerText, handleTextChange, handleTextBlur } = useQuestion(question);

    const classObj = { className: readOnly ? classes.readOnly : null };

    //#TODO TechDebt - This Component has only had a readOnly state implemented so far. It's full functionality will be implemented after the TSB project.
    return (
        <Box>
            <TextField
                variant="outlined"
                size="small"
                error={isInvalid}
                value={answerText}
                onChange={handleTextChange}
                onBlur={() => handleTextBlur(answerText)}
                disabled={disabled || isSaving || readOnly}
                className={classes.singleLinePlainText}
                InputProps={classObj}
                inputProps={classObj}
            />{' '}
            <RenderIf isTrue={isSaving}>
                <CircularProgress />
            </RenderIf>
        </Box>
    );
};

export default SingleLineText;
